import SvgIcon from '@ixigo/icons/SvgIcon';
import cn from '../utils/cn';

export const RupeeChecked = (props: React.ComponentPropsWithoutRef<'svg'>) => {
	return (
		<SvgIcon
			className={cn(props.className)}
			data-testid="ModifyBookingIcon"
			width="40"
			height="40"
			viewBox="0 0 40 40"
			fill="none"
			{...props}
		>
			<circle cx="20" cy="20" r="17" fill="#BFE0CB" />
			<path
				d="M20.0014 5.16907L7.00122 10.7631V19.1542C7.00122 26.916 12.548 32.991 20.0014 34.7531C27.4549 32.991 33.0016 26.916 33.0016 19.1542V10.7631L20.0014 5.16907Z"
				fill="#1E6B38"
			/>
			<path
				d="M20.4025 5.00317L8.32056 10.1551V18.4447C8.32056 25.8127 13.5859 31.5794 20.6611 33.2521C27.7364 31.5794 33.0017 25.8127 33.0017 18.4447V10.4794L20.4025 5.00317Z"
				fill="#2B9950"
			/>
			<path
				d="M24.722 15.4432C25.3648 15.4432 25.8293 16.0579 25.6537 16.6763V16.6763C25.5355 17.0929 25.155 17.3803 24.722 17.3803H16.4342C15.7914 17.3803 15.3269 16.7656 15.5025 16.1472V16.1472C15.6208 15.7306 16.0012 15.4432 16.4342 15.4432H24.722ZM21.6019 27.6466C21.2148 27.6466 20.8479 27.4737 20.6015 27.1751L15.6169 21.137C15.4536 20.9391 15.3631 20.6912 15.3604 20.4347V20.4347C15.354 19.8109 15.8579 19.3018 16.4817 19.3018H18.1383C18.835 19.3018 19.4243 19.1946 19.9063 18.9803C20.3882 18.7659 20.7549 18.4548 21.0064 18.047C21.2578 17.6339 21.3835 17.132 21.3835 16.5412C21.3835 15.6628 21.1216 14.9648 20.5978 14.4471C20.0739 13.9295 19.2541 13.6707 18.1383 13.6707H16.521C15.8323 13.6707 15.3326 13.0151 15.5152 12.3511V12.3511C15.6397 11.8983 16.0514 11.5845 16.521 11.5845H18.1383C19.4374 11.5845 20.5087 11.7911 21.3521 12.2041C22.1955 12.6172 22.8241 13.1897 23.238 13.9217C23.6518 14.6537 23.8587 15.4981 23.8587 16.4549C23.8587 17.3071 23.6885 18.0784 23.348 18.7685C23.0075 19.4587 22.4653 20.0208 21.7214 20.4547C20.9782 20.8883 20.0024 21.1418 18.7939 21.2153C18.7916 21.2154 18.7894 21.2157 18.7872 21.2162V21.2162C18.7563 21.2231 18.7434 21.2601 18.7635 21.2846L22.4273 25.7634C23.0239 26.4927 22.5425 27.591 21.6019 27.6466V27.6466V27.6466ZM24.7201 11.5845C25.3674 11.5845 25.8347 12.2041 25.6569 12.8265V12.8265C25.5369 13.2468 25.1516 13.5357 24.7145 13.5332L18.488 13.4976C17.8522 13.4939 17.3969 12.8825 17.5755 12.2723V12.2723C17.6948 11.8647 18.0687 11.5845 18.4935 11.5845H24.7201Z"
				fill="#EAF5EE"
			/>
			<circle
				cx="29.0015"
				cy="29.0031"
				r="8"
				transform="rotate(90 29.0015 29.0031)"
				fill="#9A7614"
			/>
			<circle
				cx="29.5015"
				cy="28.5031"
				r="7.5"
				transform="rotate(90 29.5015 28.5031)"
				fill="white"
			/>
			<circle
				cx="29.2515"
				cy="28.7531"
				r="7.25"
				transform="rotate(90 29.2515 28.7531)"
				fill="#F6C350"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M33.0311 26.0345C33.3421 26.3394 33.3421 26.8337 33.0311 27.1386L28.1023 31.9716C27.7913 32.2765 27.2872 32.2765 26.9763 31.9716L24.9715 30.0059C24.6605 29.7009 24.6605 29.2066 24.9715 28.9017C25.2824 28.5968 25.7866 28.5968 26.0975 28.9017L27.5393 30.3154L31.9051 26.0345C32.216 25.7296 32.7202 25.7296 33.0311 26.0345Z"
				fill="#9A7614"
			/>
		</SvgIcon>
	);
};

export default RupeeChecked;
